import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      nav("/");
    } catch (err) { toast.error(formatApiError(err)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] p-6">
      <div className="w-full max-w-sm">
        <h1 className="font-display text-2xl font-semibold mb-1">Request operator access</h1>
        <p className="text-sm text-zinc-500 mb-6">New accounts default to L1 Technician. Roles upgraded by your MSP owner.</p>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="reg-name" placeholder="Full name" value={name} onChange={e=>setName(e.target.value)} required className="w-full bg-zinc-950 border border-zinc-800 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-blue-500/60" />
          <input data-testid="reg-email" type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required className="w-full bg-zinc-950 border border-zinc-800 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-blue-500/60" />
          <input data-testid="reg-password" type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} required className="w-full bg-zinc-950 border border-zinc-800 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-blue-500/60" />
          <button data-testid="reg-submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md px-4 py-2">{loading?"Creating…":"Create account"} <ArrowRight size={14} /></button>
        </form>
        <p className="text-xs text-zinc-500 mt-4">Have an account? <Link to="/login" className="text-blue-400 hover:underline">Sign in</Link></p>
      </div>
    </div>
  );
}
